"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaperIcon = void 0;
var react_1 = __importDefault(require("react"));
var usePaperIcon_1 = require("./usePaperIcon");
function PaperIconSVG(_a) {
    var cache = _a.cache, collection = _a.collection, env = _a.env, fetch = _a.fetch, icon = _a.icon, onLoad = _a.onLoad, onError = _a.onError, _b = _a.originalSize, originalSize = _b === void 0 ? false : _b, style = _a.style, svgRef = _a.svgRef, props = __rest(_a, ["cache", "collection", "env", "fetch", "icon", "onLoad", "onError", "originalSize", "style", "svgRef"]);
    var iconData = (0, usePaperIcon_1.usePaperIcon)({
        cache: cache,
        collection: collection,
        env: env,
        fetch: fetch,
        icon: icon,
        onLoad: onLoad,
        onError: onError,
    });
    return (react_1.default.createElement("svg", __assign({ width: originalSize ? iconData.width : '1em', height: originalSize ? iconData.height : '1em', viewBox: iconData.viewBox, ref: svgRef, style: __assign({ fill: 'currentColor' }, style) }, props), iconData.pathData.map(function (pathData, index) { return (react_1.default.createElement("path", { key: index, d: pathData })); })));
}
function PaperIcon(_a) {
    var cache = _a.cache, _b = _a.className, className = _b === void 0 ? '' : _b, collection = _a.collection, env = _a.env, fetch = _a.fetch, icon = _a.icon, onError = _a.onError, onLoad = _a.onLoad, originalSize = _a.originalSize, spanRef = _a.spanRef, svgProps = _a.svgProps, svgRef = _a.svgRef, props = __rest(_a, ["cache", "className", "collection", "env", "fetch", "icon", "onError", "onLoad", "originalSize", "spanRef", "svgProps", "svgRef"]);
    var iconNode;
    if (react_1.default.isValidElement(icon)) {
        iconNode = icon;
    }
    else {
        iconNode = (react_1.default.createElement(PaperIconSVG, __assign({ cache: cache, collection: collection, env: env, fetch: fetch, icon: icon, onLoad: onLoad, onError: onError, originalSize: originalSize, svgRef: svgRef }, svgProps)));
    }
    return (react_1.default.createElement("span", __assign({ className: 'anticon ' + className, ref: spanRef }, props), iconNode));
}
exports.PaperIcon = PaperIcon;
PaperIcon.SVG = PaperIconSVG;
//# sourceMappingURL=PaperIcon.js.map